import React, { PureComponent, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import { Box, xcss } from '@atlaskit/primitives';

import { CopyableErrorCode } from './copyable-error-code';
import messages from './error-state.i18n';
import GenericMessage from './generic-message';

type ErrorStateProps = {
  header?: ReactNode;
  description?: ReactNode;
  onClick?: () => void;
  // NOTE: Passing the SentryID is for an for an in-flight project.
  // Please do not use until ATLAS-89472 has shipped.
  sentryId?: string;
};

const sentryIdContainerStyles = xcss({
  margin: 'space.100',
});

class ErrorState extends PureComponent<ErrorStateProps> {
  render() {
    const { header, description, onClick, sentryId } = this.props;

    return (
      <GenericMessage
        iconType="error"
        title={header || <FormattedMessage {...messages.errorHeader} />}
      >
        {description || (
          <FormattedMessage tagName="p" {...messages.errorDescription} />
        )}
        {/* render copyable sentryId if the Sentry ID is passed */}
        {sentryId && (
          <Box xcss={sentryIdContainerStyles} as="div">
            <CopyableErrorCode content={sentryId} />
          </Box>
        )}
        {onClick && (
          <CustomThemeButton appearance="link" onClick={this.props.onClick}>
            <FormattedMessage {...messages.errorLink} />
          </CustomThemeButton>
        )}
      </GenericMessage>
    );
  }
}

export default ErrorState;
